/**
 * File: TermHint.tsx
 * Path: apps/admin/src/shared/components/TermHint.tsx
 * Description: A small (i) beside an accounting term. Tap or click it for a
 * plain definition, 200 characters or fewer, written for a young reader.
 */

import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";
import { Info } from "lucide-react";
import { TERM_HINTS, type TermKey } from "../utils/termHintsData";

export const TermHint: React.FC<{ term: TermKey; name: string }> = ({ term, name }) => (
  <Popover>
    <PopoverTrigger asChild>
      <button
        type="button"
        aria-label={`What ${name} means`}
        className="inline-flex h-6 w-6 shrink-0 items-center justify-center text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Info className="h-4 w-4" aria-hidden />
      </button>
    </PopoverTrigger>
    <PopoverContent collisionPadding={16} className="w-64 max-w-[calc(100vw-2rem)] text-sm">
      <p className="font-bold">{name}</p>
      <p>{TERM_HINTS[term]}</p>
    </PopoverContent>
  </Popover>
);
